import type { Language } from '@coolblue-development/constants';
import type { InstallationServiceData } from '@coolblue-development/next-installation-services';
import type { Product } from '@features/product/typings';
import type { PropositionTypes, Store } from '@features/product-page/typings';
import { SecondChanceProduct } from '@features/second-chance/typings';

export enum OrderBlockType {
  SUMMARY = 'summary',
  DEFAULT = 'default',
  OUT_OF_STOCK = 'outOfStock',
  NOT_PART_OF_COMMUNITY = 'notPartOfCommunity'
}

export type OrderBlockProps = {
  product: Product;
  services?: InstallationServiceData[] | null;
  propositions?: PropositionTypes;
  language: Language;
  loadProductTradeIn?: boolean;
  isLeasePage?: boolean;
  isPostalCodeCheckerImprovementSplitTestInVariation: boolean;
  isDeliverableToPostalCode: boolean;
  orderBlockType?: OrderBlockType; // to determine the type of the orderBlock
  isCrossSellOnly?: boolean;
  preferredStore?: Store;
  customerEmailAddress?: string;
};

export type SecondChanceOrderBlockProps = {
  product: SecondChanceProduct;
  services?: InstallationServiceData[] | null;
  propositions?: PropositionTypes;
  language: Language;
  loadProductTradeIn?: boolean;
  isLeasePage?: boolean;
  isPostalCodeCheckerImprovementSplitTestInVariation: boolean;
  isDeliverableToPostalCode: boolean;
  orderBlockType?: OrderBlockType; // to determine the type of the orderBlock
};
